var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({
    src: _vm.bg,
  }),expression:"{\n    src: bg,\n  }",arg:"background-image"}],staticClass:"divSolvePlan"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }